import { useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Home from './home/Home'
import ProjectsIndex from './projects/ProjectsIndex'
import TitleBar from './navbars/title-bar/TitleBar'
import './App.scss'

export default function App() {
  useEffect(() => {
    window.addEventListener('orientationchange', () => {
      document.getElementById('small-nav').classList.remove('show')
      document.getElementById('small-nav-open').classList.remove('hide')
      document.getElementById('small-nav-close').classList.add('hide')
    })
  }, [])

  return (
    <Router>
      <TitleBar navigationDepth={0} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/*" element={<ProjectsIndex />} />
      </Routes>
      <footer>
        <div className="w3-animate-bottom">
          Copyright (c) 2022 Victor Olaitan All Rights Reserved.
        </div>
      </footer>
    </Router>
  )
}
